module.exports = __webpack_public_path__ + "static/media/onespan.6dfdded1.png";